import React, { useEffect, useState } from 'react';
import { db, auth } from '../../../Config/Config';
import { collection, onSnapshot, query, where } from 'firebase/firestore';

const TransactionDetailsCard = () => {
  const [amount, setAmount] = useState(0);
  const [status, setStatus] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const user = auth.currentUser;

    if (user) {
      const uid = user.uid;
      const withdrawsCollection = collection(db, 'withdraws');
      const userWithdrawsQuery = query(withdrawsCollection, where('uid', '==', uid));

      const unsubscribe = onSnapshot(
        userWithdrawsQuery,
        (snapshot) => {
          const withdrawsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

          if (withdrawsData.length > 0) {
            const latestWithdraw = withdrawsData[0];
            setAmount(latestWithdraw.amountWithdraw || 0);
            setStatus(latestWithdraw.status || 'No status');
          } else {
            setAmount(0);
            setStatus('None');
          }
        },
        (error) => {
          console.error('Error fetching withdraws: ', error);
          setError('Failed to fetch withdraw data');
        }
      );

      return () => unsubscribe();
    } else {
      setError('User not authenticated');
    }
  }, []);

  return (
    <div className="bg-[#000300] rounded-xl border border-white/10 shadow-2xl p-8 w-full transition-all duration-300 hover:scale-[1.02] max-w-2xl mb-8 relative overflow-hidden">
      {/* Gradient border effect */}
      <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.05)_50%,transparent_75%)] bg-[length:3px_3px] opacity-20"></div>
      
      {/* Title with gradient text */}
      <h2 className="text-2xl font-medium mb-6 tracking-wide">
        <span className="bg-gradient-to-r from-white to-white/70 bg-clip-text text-transparent">
          Transaction Details
        </span>
      </h2>
      
      {/* Divider */}
      <div className="w-24 h-[1px] bg-gradient-to-r from-transparent via-white to-transparent mb-6"></div>

      <div className="flex justify-between items-center relative z-10">
        {/* Amount Section */}
        <div className="flex flex-col">
          <h3 className="text-lg font-light text-white/70 mb-1">Amount</h3>
          <p className={`text-sm ${status === 'approved' ? 'text-[#00C853]' : 'text-white'}`}>
            ${amount}
          </p>
        </div>

        {/* Status Section */}
        <div className="flex flex-col">
          <h3 className="text-md font-light text-white/70 mb-1">Status</h3>
          <p className={`text-sm ${
            status === 'approved' ? 'text-[#00C853]' : 
            status === 'pending' ? 'text-yellow-400' : 
            'text-white/70'
          }`}>
            {status === "approved" ? "Completed" : status || "None"}
          </p>
        </div>
      </div>

      {/* Error display (if any) */}
      {error && (
        <div className="mt-4 text-sm text-red-400/80">
          {error}
        </div>
      )}
    </div>
  );
};

export default TransactionDetailsCard;